/**
 * Resolves when the document is loaded.
 * @returns Promise<*>
 */
export function documentLoaded() {
    return document.readyState === 'loading'
        ? new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve))
        : Promise.resolve();
}
